import React, { FC } from 'react';

import { useStanleyQueryPanel } from '../../../../providers/StanleyQueryPanelContext';
import { StanleyQueryPanelErrorState } from '../../../stanley-query-panel-error-state';

export const StanleyQueryError: FC = () => {
  const { handleTryAgain } = useStanleyQueryPanel();

  return <StanleyQueryPanelErrorState onTryAgain={handleTryAgain} />;
};
